import { Checkbox, FormGroup } from "@mui/material";
import React from "react";
import Spinner from "../../Spinner/Spinner";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

export const ServiceType = ({
  activeType,
  typeHandler,
  typesData,
  loading,
  subServices,
  subServiceHandler,
  chosenSubService,
  carHandler,
  cars,
  chosenCar,
}) => {
  return loading ? (
    <Spinner />
  ) : (
    <div className="serviceTypeWrapper">
      <FormControl sx={{ width: "100%" }}>
        <Select
          sx={{ width: "100%" }}
          onChange={(e) => {
            carHandler(e.target.value);
          }}
          value={chosenCar || "1st"}
          name="car"
          displayEmpty
        >
          <MenuItem value="1st">مهم نیست</MenuItem>
          {cars.map((car) => (
            <MenuItem key={car.id} value={car.id}>
              {car.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div className="serviceTypes">
        <span className="serviceTypeText">
          نوع خدمتی که میخواهید انجام شود را انتخاب کنید
        </span>
        {typesData.map((item, q) => (
          <div
            className={`serviceType ${activeType === item.id ? "active" : ""}`}
            onClick={() => {
              if (item?.services?.length) typeHandler(item.id, item.services);
              else typeHandler(item.id);
            }}
          >
            <span>{item.title}</span>
            <span
              className={`${activeType === item.id ? "selectedPrice" : ""}`}
            >
              {item.price} تومان
            </span>
          </div>
        ))}
      </div>
      {subServices?.length ? (
        <div className="serviceTypesDetails">
          <span>
            جزئیات سرویس های امداد خودرو <i>(انتخاب این گزینه ها ضروری است)</i>
          </span>
          <FormGroup>
            {subServices.map((item, q) => (
              <div className="subServiceItem">
                <div>
                  <Checkbox
                  className=" subServiceCheckBox"
                    color="primary"
                    onClick={() => {
                      subServiceHandler(item.id);
                    }}
                    checked={item.id === chosenSubService}
                  />

                  <span>{item.title}</span>
                </div>
                <span>{item.price} تومان</span>
              </div>
            ))}
          </FormGroup>
        </div>
      ) : null}
    </div>
  );
};
